<template>
  <Html lang="ru">
    <Body>
      <NuxtLoadingIndicator />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </Body>
  </Html>
</template>

<script setup lang="ts">
useHead({
  title: 'Собери команду лучших в сезоне-2025/26',
  meta: [
    {
      name: 'description',
      content: 'Собери 11 лучших сезона в схеме 4-3-3 и посмотри, как голосовали читатели Sports.ru.',
    },
  ],
});
</script>
